import React from 'react';

export default function Container({children, className = 'section'}) {
    return <div className={`${className} px-8 lg:p-0`}>{children}</div>;
}